// extracted by mini-css-extract-plugin
export default {"nav-tgl":"NavMenu_nav-tgl__-C1hW","active":"NavMenu_active__BRXcL"};